<template>
  <RevTooltip position="bottom">
    <template #trigger="{ hide, show }">
      <button
        class="text-static-default-low cursor-pointer whitespace-nowrap"
        @click="show"
        @focusin="show"
        @focusout="hide"
        @mouseenter="show"
        @mouseleave="hide"
      >
        <FormattedMessage
          :class="{
            'body-2': !shouldDisplayStrikedPrice,
            'body-2-striked': shouldDisplayStrikedPrice,
          }"
          :definition="translations.originalPriceDisplayHtml"
        >
          <template #price>
            <span class="body-2-striked">
              {{ i18n.price(price) }}
            </span>
          </template>
        </FormattedMessage>
      </button>
    </template>

    {{ i18n(translations.strikedPriceExplanation) }}
  </RevTooltip>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api'
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevTooltip } from '@ds/components/Tooltip'

import translations from './StrikedProductPrice.translations'

defineProps<{
  price: number
}>()

const i18n = useI18n()

const {
  market: { countryCode },
} = useMarketplace()

const shouldDisplayStrikedPrice = computed(
  () => ![MarketCountryCode.JP].includes(countryCode),
)
</script>
